import {SECRET_TOKEN_LENGTH} from '../constants'

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export function generateSecretToken(): string {
	let result = ''
	for (let i = 0; i < SECRET_TOKEN_LENGTH; i++) {
		result += CHARS.charAt(Math.floor(Math.random() * CHARS.length))
	}

	return result
}
